/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

//验证手机号
export function verifyTel(val) {
  return /^1[3-9]\d{9}$/.test(val);
}

//验证邮箱
export function verifyEmail(val) {
  return /^\S+?@\S+?\.\S+?$/.test(val);
}

//验证身份证
export function verifyIDcard(val) {
  return /(^\d{15}\$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
}

//验证特殊字符
export function verifySpecialCharacters(val) {
  return !/[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im.test(val);
}

//验证4位16进制数
export function verifyHexDigit(val) {
  return /^[A-Fa-f0-9]{4}$/.test(val);
}